import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { getLogin, getEmisor, clearErrors } from '../../actions';
import { Redirect } from "react-router-dom";
import { messageTypeEnum } from '../../enum';
import BasicMessage from '../messages/basicMessage';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = { token: null, mgType: '', message: '' };
  }

  componentDidUpdate(prevProps, prevState) {
    const { loginState, errorState } = this.props;

    if (loginState?.token && !this.props.isLoading) {
      this.props.getEmisor(loginState.token.access_token, loginState.token.userName);
      this.setState({
        token: loginState.token,
      });
    }
    if (this.props.errorState !== prevProps.errorState) {
      if (errorState && errorState.error !== null) {

        this.setState({
          mgType: errorState?.error ? messageTypeEnum.error : messageTypeEnum.success,
          message: 'Usuario o contraseña incorrectos'
        });
      }
    }
  }


  redirect = () => {
    return <Redirect to='/' />;
  }

  renderError = ({ error, touched }) => {
    if (touched && error) {
      return (
        <div className="error-message">
          {error}
        </div>
      );
    }
  }


  renderInput = ({ input, label, meta }) => {
    const className = `field ${meta.error && meta.touched ? 'error' : ''}`;

    return (
      <div className={className}>
        <label> {label} </label>
        <div className="ui left icon input">
          <input {...input} autoComplete="off" />
          <i className="user icon"></i>
        </div>
        {this.renderError(meta)}
      </div>
    );
  };

  renderPassword = ({ input, label, meta }) => {
    const className = `field ${meta.error && meta.touched ? 'error' : ''}`;

    return (
      <div className={className}>
        <label> {label} </label>
        <div className="ui left icon input">
          <input type="password" {...input} />
          <i className="lock icon"></i>
        </div>
        {this.renderError(meta)}
      </div>
    );
  };

  onSubmit = (formValues) => {
    this.props.getLogin(formValues);
  }

  closeMessage = () => {
    this.props.clearErrors();
  }

  render() {
    if (this.state.token) return this.redirect();

    return (
      <>
        <div className="ui equal stackable width grid login-page" style={{ marginTop: "25vh" }} >
          <div className="six wide stackable column centered">
            <div className="ui segment">
              <div className="title center-text">
                <span>Favor ingrese su usuario y contraseña</span>
              </div>
              <form className="ui form" onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Field required name="Usuario" component={this.renderInput} label="Usuario: " />
                <Field required name="Password" component={this.renderPassword} label="Contraseña: " />
                <div className="ui right aligned grid">
                  <div className="sixteen wide column">
                    <button className="ui button primary mb-1">Aceptar</button>
                  </div>
                </div>
              </form>
              <BasicMessage message={this.state.message} type={this.state.mgType} onClick={() => this.closeMessage()} />
            </div>
          </div>
        </div>
      </>
    );
  }

}

const validate = (formValues) => {
  const errors = {};

  if (!formValues.Usuario) {
    errors.Usuario = 'Debe ingresar el usuario';
  }

  if (!formValues.Password) {
    errors.Password = 'Debe ingresar la contraseña';
  }

  return errors;
}

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    isLoading: state.isLoadingState,
    errorState: state.errorState,
  };
}

const formWrapperd = reduxForm({
  form: 'LoginForm',
  validate
})(Login);

export default connect(mapStateToProps, { getLogin, getEmisor, clearErrors })(formWrapperd);